export const SIGNICAT_VERIFICATION_ERRORS = {
  documentVerificationResult: 'Document Verification failed.',
  documentAgeValidation: 'Document does not meet the age requirement.',
  documentPoliceRecord: 'Police record has returned issues.',
  documentDataConsistency: 'There is a discrepancy in the information provided.',
  documentDataValidation: 'Some information on your document could not be validated.',
  documentImageIntegrity: 'The image of your document appears to be corrupted or unclear.',
  documentDataComparison: 'Data on your document does not match the provided information.',
  documentCompromisedDocument: 'Document appears to be compromised or altered.',
  facialSimilarityResult: 'Facial Recognition could not confirm your identity.',
  facialSimilarityImageIntegrity: 'Image for facial recognition is unclear or corrupted.',
  facialSimilarityVisualAuthenticity: 'Visual authenticity of your facial image could not be verified.',
  facialSimilaritySimilarityScore: 'Facial similarity score indicates a mismatch.',
};

export const EDD_DOCUMENTS = [
  {
    id: 'ProofOfAddress',
    name: 'Proof of address',
  },
  {
    id: 'SalarySlip',
    name: 'Salary Slip',
  },
  {
    id: 'SourceOfWealthBankStatement',
    name: 'Source Of Wealth Bank Statement',
  },
  {
    id: 'ResidencePermit',
    name: 'Residence Permit',
  },
  {
    id: 'IdPassport',
    name: 'ID/Passport',
  },
];

export const DOCUMENT_VALIDITY_STATUSES = {
  valid: 'VALID',
  expiringSoon: 'EXPIRING_SOON',
  expired: 'EXPIRED',
};

export const DOCUMENT_REVIEW_STATUSES = {
  pending: 'KYC_PENDING',
  approved: 'KYC_APPROVED',
  rejected: 'KYC_REJECTED',
};
